import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import CurrencySelector from '../../../components/CurrencySelector';
import OptionsContainer from '../../../components/OptionsContainer';
import FlexBox from '../../../../../components/FlexBox';
import DatePicker from '../../../components/DatePicker/index';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';
import Select from 'react-select';
import ExpenseForSelect from '../../../components/ExpenseForSelect';

export class AdditionalItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regexNumber = /^(0*[1-9]\d*(\.\d{0,2})?|0+\.\d*[1-9]\d*)$/;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    if (regexNumber.test(value)) {
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    } else {
      value = '';
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    }
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  handleChangeInsureds = (selectedClaimFor) => {
    if (selectedClaimFor) {
      const item = { ...this.props.item, ...{ ['selectedClaimFor']: selectedClaimFor } };
      this.change(item);
    }
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };
  render() {
    const { item } = this.props;
    const {
      disabled,
      removable,
      validatorGroup,
      validationCounter,
      insuredsList,
      isClaimForFieldEnabled,
      intl
    } = this.props;
    const selectedClaimForList = !!item.selectedClaimFor && typeof item.selectedClaimFor.toJS === 'function'
      ? item.selectedClaimFor.toJS()
      : item.selectedClaimFor || [];

    return (
      <div className="expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto">
                <Button className='base-button primary-button' onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
        </div>
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <ExpenseForSelect
              validatorGroup={validatorGroup}
              validationCounter={validationCounter}
              defaultValue={selectedClaimForList}
              disabled={disabled}
              options={insuredsList}
              onChange={(v) => this.handleChangeInsureds(v)}
              value={selectedClaimForList}
              fieldName={messages.expenseFor}
              tooltipContent={intl.formatMessage(messages.selectInsuredForExpense)}
              messages={messages}
              placeholder={intl.formatMessage({ id: 'fastCover.selectInsureds' })}
            />
          </div>
          <div className="form-group col-sm-5 col-md-5">
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.descriptionOfItem}
              fieldName={messages.descriptionOfExpense}
            >
              <Textbox
                disabled={disabled}
                name="descriptionOfItem"
                type="text"
                onChange={this.onChange('descriptionOfItem')}
                value={item.descriptionOfItem}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.descriptionOfExpense) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              name="dateOfExpense"
              validators={[checkDateOnly, required]}
              group={validatorGroup}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              defaultValue={item.dateOfExpenses}
              fieldName={messages.dateOfExpense}
            >
              <DatePicker
                name="dateOfExpense"
                disabled={disabled}
                type="text"
                onDayChange={this.handleDayChange('dateOfExpenses')}
                value={item.dateOfExpenses}
                placeholder="dd/mm/yyyy"
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.dateOfExpense) }}
                />
              </ErrorMessage>
              <ErrorMessage for="checkDateOnly">
                <FormattedMessage
                  {...messages.checkEventDate}
                  values={{ defaultMessage: intl.formatMessage(messages.dateOfExpense) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountClaimed}
              fieldName={messages.amountClaimed}
            >
              <Textbox
                disabled={disabled}
                name="amountClaimed"
                type="number"
                onChange={this.onChangeAmount('amountClaimed')}
                value={item.amountClaimed}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.amountClaimed) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currency}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currency')}
                disabled={disabled}
                value={item.currency}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.currency) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12 col-md-12">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.providerName}
              fieldName={messages.providerName}
            >
              <Textbox
                disabled={disabled}
                name="providerName"
                type="text"
                onChange={this.onChange('providerName')}
                value={item.providerName}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.providerName) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
      </div>
    );
  }
}

AdditionalItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  intl: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StandardVTCMedicalBenefits/components/Additional/AdditionalItem.js